import React from 'react';
import { Grid, withStyles } from '@material-ui/core';
import styles from './style';
import Label, { LabelContainer } from "storybookComponents/EditableLabel"
import UserContext from 'context/UserContext';
import Recurring from "./components/EventRecurring"

export default withStyles(styles)(({ values, onTryToEdit, classes, setValues, setFieldValue, status, startAt, endAt, showNotification }) => {

  const { subOrgDetails } = React.useContext(UserContext);

  const onDateTimeChange = (data) => {
    setValues({ ...values, ...data })
  }

  const onError = (msg) => {
    showNotification(msg, "error")
  }

  return (
    <Grid id="headerGrid" className={`${classes.textCenter} ${classes.headerContainer}`} item >
      <div><img className={classes.headerImageContainer} src={subOrgDetails.propertyLogoUrl} alt="logo" /></div>
      <LabelContainer className={classes.labelContainer}>
        <Label id="titleInput" keyName="title" handleBlur={setFieldValue} color="darkBlack" name="Event Title" className={classes.titleClass} text={values.title} />
      </LabelContainer>
      <div className={classes.dateContainer}>
        <LabelContainer>
          <Label
            name="Event Date & Time"
            eventTimeComponent
            handleBlur={onDateTimeChange}
            className={classes.dateClass}
            text={{ startAt: startAt ? startAt : "", endAt: endAt ? endAt : "" }}
            disabled={status === "published" || status === "invited" || status === "invite_scheduled"}
            eventDatetime
            onError={onError}
            onTryToEdit={onTryToEdit}
            timezoneAbbr={subOrgDetails.timezoneAbbr}
            timezoneString={subOrgDetails.timezoneString}
            hideEditIcon
          />
        </LabelContainer>
        <div className={classes.recurranceContainer}><Recurring values={values} timezoneString={subOrgDetails.timezoneString} setValues={setValues} /></div>
      </div>
    </Grid>
  );
})
